import { useTranslation } from "react-i18next";
import { useGetPreference } from "../../api/preference.api";
import { PreferencesCotation } from "./preferencesCotation";
import { PreferencesProduct } from "./preferencesProduct";

export const Preferences = () => {
  const { t } = useTranslation("common");
  const { data: preference } = useGetPreference();

  if (!preference) return <div>{t("states.loading")}</div>;

  return (
    <div className="flex flex-1 flex-col gap-8">
      <PreferencesCotation preference={preference} />
      <PreferencesProduct pref={preference?.winePreference} />
    </div>
  );
};
